// extracted by mini-css-extract-plugin
export default {"invalid-error":"InsuredObjectForm_invalid-error__B23-M"};